import produce from 'immer';
import { handleActions } from 'redux-actions';
import actions from './actions';
import { updateStoreWithPath } from '../../../lib/common';
import { _LIST_PAGINATION_MODEL, LIST_SUMMARY_MODEL } from '../app/models';
import {
  REMOTE_IMAGE_SPLASH_LIST_SEARCH_OPTION_MODEL,
  REMOTE_IMAGE_REFERRAL_LIST_SEARCH_OPTION_MODEL,
  REMOTE_IMAGE_SPLASH_DETAIL_MODEL,
  REMOTE_IMAGE_REFERRAL_DETAIL_MODEL,
} from './models';

/**
 *  INITIAL STATE
 */
const initialState = {
  /**
   *  원격 스플래시 이미지 리스트
   */
  remoteImageSplashList: {
    /**
     *  리스트
     */
    list: [],
    /**
     *  검색 박스
     */
    searchData: REMOTE_IMAGE_SPLASH_LIST_SEARCH_OPTION_MODEL,
    /**
     *  검색 옵션
     */
    searchOption: REMOTE_IMAGE_SPLASH_LIST_SEARCH_OPTION_MODEL,
    /**
     *  리스트 pagination
     */
    pagination: _LIST_PAGINATION_MODEL,
    /**
     *  집계 데이터
     */
    summary: LIST_SUMMARY_MODEL,
  },
  /**
   *  원격 레퍼럴 이미지 리스트
   */
  remoteImageReferralList: {
    /**
     *  리스트
     */
    list: [],
    /**
     *  검색 박스
     */
    searchData: REMOTE_IMAGE_REFERRAL_LIST_SEARCH_OPTION_MODEL,
    /**
     *  검색 옵션
     */
    searchOption: REMOTE_IMAGE_REFERRAL_LIST_SEARCH_OPTION_MODEL,
    /**
     *  리스트 pagination
     */
    pagination: _LIST_PAGINATION_MODEL,
    /**
     *  집계 데이터
     */
    summary: LIST_SUMMARY_MODEL,
  },
  /**
   *  원격 스플래시 이미지 생성/수정
   */
  remoteImageSplashDetail: REMOTE_IMAGE_SPLASH_DETAIL_MODEL,
  /**
   *  원격 레퍼럴 이미지 생성/수정
   */
  remoteImageReferralDetail: REMOTE_IMAGE_REFERRAL_DETAIL_MODEL,
};

/**
 *  REDUCER
 */
export default handleActions(
  {
    /**
     *  데이터 변경하기
     */
    [actions.SET_DATA]: (state, action) => {
      return produce(state, (draft) => {
        updateStoreWithPath(action.payload.path, action.payload.value, draft);
      });
    },

    /**
     *  원격 스플래시 이미지 리스트 요청하기
     */
    [actions.GET_REMOTE_IMAGE_SPLASH_LIST_SUCCESS]: (state, action) => {
      return produce(state, (draft) => {
        draft.remoteImageSplashList = {
          ...draft.remoteImageSplashList,
          ...action.payload.remoteImageList,
        };
      });
    },

    /**
     *  원격 레퍼럴 이미지 리스트 요청하기
     */
    [actions.GET_REMOTE_IMAGE_REFERRAL_LIST_SUCCESS]: (state, action) => {
      return produce(state, (draft) => {
        draft.remoteImageReferralList = {
          ...draft.remoteImageReferralList,
          ...action.payload.remoteImageList,
        };
      });
    },

    /**
     *  원격 스플래시 이미지 상세 정보 요청하기
     */
    [actions.GET_REMOTE_IMAGE_SPLASH_DETAIL_SUCCESS]: (state, action) => {
      return produce(state, (draft) => {
        draft.remoteImageSplashDetail = {
          ...draft.remoteImageSplashDetail,
          ...action.payload.remoteImageDetail,
        };
      });
    },

    /**
     *  원격 레퍼럴 이미지 상세 정보 요청하기
     */
    [actions.GET_REMOTE_IMAGE_REFERRAL_DETAIL_SUCCESS]: (state, action) => {
      return produce(state, (draft) => {
        draft.remoteImageReferralDetail = {
          ...draft.remoteImageReferralDetail,
          ...action.payload.remoteImageDetail,
        };
      });
    },
  },
  initialState,
);
